<template>
  <div id="settingContainer" class="page-container">
    <div class="page-content">
      <div v-if="setingChanged" class="warning-popup">
        <div class="body flex-center" style="width: 430px">
          <div class="fs-500 fc-FFFFFF fs-14">
            You’ve made changes to your settings
          </div>
          <div @click="undoSaveSetting" class="cursor-pointer ml-auto undo-bottom flex-mid">
            Undo
          </div>
          <div @click="saveChanges" class="cursor-pointer save-bottom flex-mid">
            Save Changes
          </div>
        </div>
      </div>
      <div class="flex-row-center mt-16">
        <img @click.prevent="refresh" src="../assets/images/navbar/ic_settings.webp" class="icon-pages" />
        <span class="page-title">Settings</span>
        <div class="page-des page-des-line-button">
          Configure general settings and customize experiences
        </div>
        <div class="button-title">
          <el-button class="btnAddSettings" type="primary" @click="saveChanges">Save Changes</el-button>
        </div>
      </div>

      <div class="div-page-content flex-column mt-32 relative">
        <el-form class="margin-subpages">
          <div id="generalSettings">
            <span class="sub-title">GENERAL SETTINGS</span>
            <div class="line-style mt-24" />
            <div style="margin-top: 32px; margin-right: 100px">
              <el-form-item style="margin-bottom: 16px">
                <span slot="label" class="inputLabelStyle">Company Name</span>
                <el-input disabled class="inputReportStyle" 
                v-model="user.company_name" :class="[ blurMode ?  'blurelement': '' ]"></el-input>
              </el-form-item>
            </div>
            <div style="margin-top: 32px; margin-right: 100px">
              <div>
                <div class="header-text">Pulse & Report Schedule</div>
                <span class="description-text">Set the time that questions and reports are delivered to your teams</span>
              </div>
            </div>
            <div id="formReport" class="mx-2 mt-32 grid-2-50">
              <div>
                <el-form-item style="margin-bottom: 16px" prop="date1" v-if="settingData.gen_question == 'Y'">
                  <span slot="label" class="inputLabelStyle">Daily Pulse</span>
                  <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 15:00:00' }" format="h:mm A"
                    value-format="h:mm A" class="inputReportStyle" type="fixed-time" v-model="settingData.starttime"
                    placement="bottom-start"></el-time-picker>
                  <span style="
                      pointer-events: none;
                      font-size: 18px;
                      color: #b5b5b5;
                      position: absolute;
                      left: 207px;
                      top: 6px;
                    ">Mon - Fri</span>
                </el-form-item>

                <el-form-item style="margin-bottom: 16px" prop="date3" v-if="settingData.report_dailyboss == 'Y'">
                  <span slot="label" class="inputLabelStyle">Daily Insights</span>
                  <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 14:00:00' }" format="h:mm A"
                    value-format="h:mm A" class="inputReportStyle" type="fixed-time"
                    v-model="settingData.report_dailyboss_time" placement="bottom-start"></el-time-picker>
                  <span style="
                      pointer-events: none;
                      font-size: 18px;
                      color: #b5b5b5;
                      position: absolute;
                      left: 207px;
                      top: 6px;
                    ">Tue - Sat</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item prop="date4" v-if="settingData.report_weeklyboss == 'Y'">
                  <span slot="label" class="inputLabelStyle">Weekly Insights</span>
                  <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 14:00:00' }" format="h:mm A"
                    value-format="h:mm A" class="inputReportStyle" type="fixed-time"
                    v-model="settingData.report_weeklyboss_time" placement="bottom-start"></el-time-picker>
                  <span style="
                      pointer-events: none;
                      font-size: 18px;
                      color: #b5b5b5;
                      position: absolute;
                      left: 207px;
                      top: 6px;
                    ">Monday</span>
                </el-form-item>
                <el-form-item prop="date4" v-if="settingData.report_monthly_insights == 'Y'">
                  <span slot="label" class="inputLabelStyle">Monthly Insights</span>
                  <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 16:00:00' }" format="h:mm A"
                    value-format="h:mm A" class="inputReportStyle" type="fixed-time"
                    v-model="settingData.report_monthlyboss_time" placement="bottom-start"></el-time-picker>
                  <span style="
                      pointer-events: none;
                      font-size: 18px;
                      color: #b5b5b5;
                      position: absolute;
                      left: 207px;
                      top: 6px;
                    ">1st of Mo</span>
                </el-form-item>
              </div>
            </div>

          </div>

          <!-- <div style="margin-top: 20px; margin-right: 100px; padding-bottom: 32px;">
            <div>
              <div class="header-text">Conversation Intensity</div>
              <span class="description-text">Set the number of standard open-ended questions to include each week in the
                daily pulse surveys</span>
            </div>
            <div class="slider-demo-block mt-16" style="width: 40%;" v-if="settingData.limit">
              <el-slider v-model="settingData.limit.openend" :step="1" :max="4" :marks="{0: '0', 1: '1', 2: '2', 3: '3', 4: 'Max'}" :show-tooltip="false" show-stops />
            </div>
          </div> -->

          <div style="margin-top: 32px;">
            <div>
              <div class="header-text">Performance Boost Notice</div>
              <span class="description-text">Set the optimal review schedule for managers to provide performance
                reviews</span>
            </div>
            <div id="formReport" class="mx-2 mt-32 grid-2-50">
              <div v-if="settingData.performance_review">
                <el-form-item style="margin-bottom: 16px">
                    <span slot="label" class="inputLabelStyle">Pending after</span>
                    <el-select v-model="settingData.performance_review.pending" class="inputReportStyle" placeholder="Select duration" @change="pendingAfterChange">
                      <el-option v-for="month in [1, 2, 3]" :key="month" :label="`${month} ${month === 1 ? 'month' : 'months'}`" :value="month"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item style="margin-bottom: 16px">
                    <span slot="label" class="inputLabelStyle">Overdue after</span>
                    <el-select v-model="settingData.performance_review.overdue" class="inputReportStyle" placeholder="Select duration">
                      <el-option v-for="month in overdueMonths" :key="month" :label="`${month} ${month === 1 ? 'month' : 'months'}`" :value="month"></el-option>
                    </el-select>
                  </el-form-item>
              </div>
            </div>
            <div v-if="settingData.performance_review" class="flex-center mt-18">
              <div class="switch mr-16">
                <div class="can-toggle">
                  <input class="input" type="checkbox" id="ai_review_feedback"
                    v-model="settingData.performance_review.ai_review_feedback" />
                  <label for="ai_review_feedback" :class="`${settingData.performance_review.ai_review_feedback
                    ? 'power-on'
                    : 'power-off'
                    }`">
                    <div class="switch-body flex-mid">
                      <div v-if="settingData.performance_review.ai_review_feedback" class="mr-auto ml-14 mt-2">
                        ON
                      </div>
                      <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                    </div>
                  </label>
                </div>
              </div>
              <span class="fc-4A4A4A fs-14 fw-700">AI-Reviewed Feedback</span>
            </div>
          </div>

          <div style="margin-top: 32px; margin-right: 100px">
            <div>
              <div class="header-text">Company Holidays</div>
              <span class="description-text">Daily pulse questions are paused on upcoming company
                holidays</span>
            </div>
            <div v-if="settingData['holiday_tag'] &&
              settingData['holiday_tag'].length > 0
              " style="display: inline-block" class="pt-12">
              <el-tag class="HolidayTagStyle" v-for="(item, index) in settingData['holiday_tag']" :key="item">
                {{ item }}
                <i @click="removeTag(index)" style="margin-left: 2px; margin-right: 2px; font-size: 18px"
                  class="el-icon-close"></i>
              </el-tag>
            </div>
            <div v-bind:style="'display: flex; padding-top: ' +
              getPaddingStyle(settingData['holiday_tag'])
              " v-if="settingData['holiday_val']">
              <el-date-picker :clearable="false" :editable="false" @change="confirmHolidayDatepicker"
                class="dialogInputDatepicker" ref="datepicker_holiday" type="dates" v-model="settingData['holiday_val']"
                placement="bottom-start"></el-date-picker>
              <img @click="showDatepickerHoliday" class="btn_AddHolidayStyle"
                src="@/assets/images/settings/btn_AddHolidays@2x.png" />

                <!-- <div>
                  <el-button style="width:250px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;margin-right: 32px;padding: 0px;" @click="showModal_holiday_presets=true">
                    <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                      <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                        <path d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z"/>
                      </svg>
                      <span>Set Presonal Holiday</span>
                    </div>
                  </el-button>


                  
                </div>
                <div style="margin-top: 8px; font-size: 14px;">{{ presetlistAll?presetlistAll.length:0 }} Holiday Presets Active</div> -->
            </div>
           

            
          </div>
         
          

          <div id="divMedal" style="margin-top: 50px; margin-bottom: 50px">
            <span class="sub-title">OPT-IN FEATURES</span>

            <!-- <div class="line-style mt-24" style="margin-right: 48px" />
            <div class="flex">
              <div>
                <div ref="medal-of-excellence" class="txt-header mt-24">
                  Medal of Excellence
                </div>
                <div class="description-text">
                  Members set as “Leaders” will have access to medals of
                  excellence that they can give as recognition, without limit.
                  The name of each medal can be customized here
                </div>
              </div>
              <el-popover
                placement="bottom"
                title="Languages"
                width="180"
                trigger="click"
                class="mt-24 ml-auto"
                v-model="popover.visibleMedal"
                v-if="settingData.medalsForLeaders_checked && multiLang"
              >
                <div>
                  <div
                    class="select-lang in-popover flex-center"
                    @click="setLanguage('medals', 'EN')"
                  >
                    English (Default)
                  </div>
                  <div
                    class="select-lang in-popover flex-center"
                    @click="setLanguage('medals', 'TH')"
                  >
                    TH - ไทย
                  </div>
                </div>
                <el-button type="text" slot="reference" class="lang-button">
                  <div class="flex-mid pl-8 pr-12">
                    <img
                      :src="$utils('icons', 'flag_purple_20dp')"
                      alt="icons_flag_purple_20dp"
                    />
                    <div class="ml-auto">
                      {{ popover.langMedal }}
                    </div>
                  </div>
                </el-button>
              </el-popover>
            </div> -->
            <!-- <div class="mt-24">
              <div class="flex-center mt-18">
                <div class="switch mr-16">
                  <div class="can-toggle">
                    <input
                      class="input"
                      type="checkbox"
                      id="medalsForLeaders_checked"
                      v-model="settingData.medalsForLeaders_checked"
                    />
                    <label
                      for="medalsForLeaders_checked"
                      :class="`${
                        settingData.medalsForLeaders_checked
                          ? 'power-on'
                          : 'power-off'
                      }`"
                    >
                      <div class="switch-body flex-mid">
                        <div
                          v-if="settingData.medalsForLeaders_checked"
                          class="mr-auto ml-14 mt-2"
                        >
                          ON
                        </div>
                        <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                      </div>
                    </label>
                  </div>
                </div>
                <span class="fc-4A4A4A fs-14 fw-700">Medals for Leaders</span>
              </div>
              <div
                :class="`setting-row ${
                  settingData.medalsForLeaders_checked
                    ? 'mt-28'
                    : 'expand-setting'
                }`"
                :style="`margin-left: 7px; height: ${
                  !settingData.medalsForLeaders_checked
                    ? 0
                    : uiSetting.medalsForLeaders_checked_row
                }px;`"
                id="formMedal"
              >
                <div class="flex" ref="medalsForLeaders_checked_row">
                  <div style="margin-right: 14px">
                    <img
                      src="../assets/images/settings/Creativity-on@3x.png"
                      class="imgMedal"
                    />
                    <input
                      v-if="popover.langMedal == 'EN'"
                      class="input-medal ellipsis"
                      v-model="settingData.Creativity"
                    />
                    <div v-else>
                      <input
                        class="input-medal ellipsis"
                        v-model="settingData.CreativityTH"
                      />
                      <div class="popup">
                        <div class="fs-10 fw-700">DEFAULT</div>
                        <div class="fs-12 opa-07">
                          {{ settingData.Creativity }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="margin-right: 14px">
                    <img
                      src="../assets/images/settings/Initiative-on@3x.png"
                      class="imgMedal"
                    />
                    <input
                      v-if="popover.langMedal == 'EN'"
                      class="input-medal ellipsis"
                      v-model="settingData.Initiative"
                    />
                    <div v-else>
                      <input
                        class="input-medal ellipsis"
                        v-model="settingData.InitiativeTH"
                      />
                      <div class="popup">
                        <div class="fs-10 fw-700">DEFAULT</div>
                        <div class="fs-12 opa-07">
                          {{ settingData.Initiative }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="margin-right: 14px">
                    <img
                      src="../assets/images/settings/Kindness-on@3x.png"
                      class="imgMedal"
                    />
                    <input
                      v-if="popover.langMedal == 'EN'"
                      class="input-medal ellipsis"
                      v-model="settingData.Kindness"
                    />
                    <div v-else>
                      <input
                        class="input-medal ellipsis"
                        v-model="settingData.KindnessTH"
                      />
                      <div class="popup">
                        <div class="fs-10 fw-700">DEFAULT</div>
                        <div class="fs-12 opa-07">
                          {{ settingData.Kindness }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="margin-right: 14px">
                    <img
                      src="../assets/images/settings/Strength-on@3x.png"
                      class="imgMedal"
                    />
                    <input
                      v-if="popover.langMedal == 'EN'"
                      class="input-medal ellipsis"
                      v-model="settingData.Strength"
                    />
                    <div v-else>
                      <input
                        class="input-medal ellipsis"
                        v-model="settingData.StrengthTH"
                      />
                      <div class="popup">
                        <div class="fs-10 fw-700">DEFAULT</div>
                        <div class="fs-12 opa-07">
                          {{ settingData.Strength }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="margin-right: 14px">
                    <img
                      src="../assets/images/settings/Charisma-on@3x.png"
                      class="imgMedal"
                    />
                    <input
                      v-if="popover.langMedal == 'EN'"
                      class="input-medal ellipsis"
                      v-model="settingData.Charisma"
                    />
                    <div v-else>
                      <input
                        class="input-medal ellipsis"
                        v-model="settingData.CharismaTH"
                      />
                      <div class="popup">
                        <div class="fs-10 fw-700">DEFAULT</div>
                        <div class="fs-12 opa-07">
                          {{ settingData.Charisma }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="margin-right: 14px">
                    <img
                      src="../assets/images/settings/Intelligence-on@3x.png"
                      class="imgMedal"
                    />
                    <input
                      v-if="popover.langMedal == 'EN'"
                      class="input-medal ellipsis"
                      v-model="settingData.Intelligence"
                    />
                    <div v-else>
                      <input
                        class="input-medal ellipsis"
                        v-model="settingData.IntelligenceTH"
                      />
                      <div class="popup">
                        <div class="fs-10 fw-700">DEFAULT</div>
                        <div class="fs-12 opa-07">
                          {{ settingData.Intelligence }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="line-style mt-24" />
            <div class="flex">
              <div>
                <div ref="recognition-values" class="header-text mt-24">
                  Recognition Values
                </div>
                <div class="description-text">
                  Peer and manager-driven recognition can be guided or forced to
                  align with specific company values, represented as hashtags in
                  the recognition interactions
                </div>
              </div>
              <el-popover placement="bottom" title="Languages" width="180" trigger="click" class="mt-24 ml-auto"
                v-model="popover.visibleRecognition" v-if="settingData.recognitionValue_checked && multiLang">
                <div>
                  <div v-for="val in language" :key="val.code" class="select-lang in-popover flex-center" @click="setLanguage('recognition', val.code.toUpperCase())">
                    
                    {{val.text}}
                    
                  </div>
                  <!-- <div class="select-lang in-popover flex-center" @click="setLanguage('recognition', 'EN')">
                    English (Default)
                  </div>
                  <div class="select-lang in-popover flex-center" @click="setLanguage('recognition', 'TH')">
                    TH - ไทย
                  </div> -->
                 
                </div>
                <el-button type="text" slot="reference" class="lang-button">
                  <div class="flex-mid pl-8 pr-12">
                    <img :src="$utils('icons', 'flag_purple_20dp')" alt="icons_flag_purple_20dp" />
                    <div class="ml-auto">
                      {{ popover.langRecognition }}
                    </div>
                  </div>
                </el-button>
              </el-popover>
            </div>
            <div class="flex-center mt-18">
              <div class="switch mr-16">
                <div class="can-toggle">
                  <input class="input" type="checkbox" id="recognitionValue_checked"
                    v-model="settingData.recognitionValue_checked" />
                  <label for="recognitionValue_checked" :class="`${settingData.recognitionValue_checked
                    ? 'power-on'
                    : 'power-off'
                    }`">
                    <div class="switch-body flex-mid">
                      <div v-if="settingData.recognitionValue_checked" class="mr-auto ml-14 mt-2">
                        ON
                      </div>
                      <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                    </div>
                  </label>
                </div>
              </div>
              <span class="fc-4A4A4A fs-14 fw-700">Recognition Values</span>
            </div>
            <div :class="`setting-row ${settingData.recognitionValue_checked
              ? 'mt-24'
              : 'expand-setting'
              }`" :style="`margin-left: 7px; height: ${!settingData.recognitionValue_checked
    ? 0
    : uiSetting.recognitionValue_checked_row
    }px;`">
              <div ref="recognitionValue_checked_row">
                <div v-if="popover.langRecognition == 'EN'">
                  <draggable v-model="recognitionDataSetting" v-bind="dragOptions" @update="updateCradList"
                    class="flex-center flex-wrap" style="gap: 12px 0">
                    <!-- <span
                      v-for="values in recognitionValue"
                      :key="values.value"
                      class="recognition-tags flex-center"
                    >
                      <span>{{ values.label }}</span>
                      <span
                        class="ml-12 fs-16 cursor-pointer"
                        @click="removeRecognitionTag(values.value)"
                        ><i class="el-icon-close" style="font-weight: 700"></i
                      ></span>
                    </span> -->
                    <div v-for="(value, index) in recognitionValue" :key="value.value + '_input'" class="relative">
                      <input class="recognition-tags input-growup" :style="$utils('fontStyle', value.label) + ' !important'
                        " type="text" :id="`input-growup-${index}`" v-model="value.label" @input="(event) => onInputRecognitionModel(event, index)
    " />
                      <span class="ml-12 fs-16 cursor-pointer icon-close" @click="removeRecognitionTag(value.value)"><i
                          class="el-icon-close" style="font-weight: 700"></i></span>
                      <span class="span-growup" :id="`span-growup-${index}`"></span>
                    </div>
                  </draggable>
                  <div class="mt-12 flex-center" style="flex-wrap: wrap; gap: 12px 0">
                    <span @click="showRecognitionInput" v-if="!saveRecognitionInput"
                      class="recognition-tags flex-center cursor-pointer">
                      <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                      <span class="">New Value</span>
                    </span>
                    <input class="recognition-tags input" v-if="saveRecognitionInput" style="height: 18px"
                      v-model="saveRecognitionValue" ref="saveRecognitionInput"
                      @keyup.enter="handleInputRecognitionConfirm" @blur="handleInputRecognitionConfirm" />
                  </div>
                </div>
                <div v-else>
                  <draggable v-model="recognitionDataSetting" v-bind="dragOptions" @update="updateCradList"
                    class="flex-center flex-wrap" style="gap: 12px 0">
                    <div v-for="(value, index) in recognitionValue" :key="value.value + '_input'" class="relative">
                      <input class="recognition-tags input-growup" :style="$utils('fontStyle', value.labelTh) + ' !important'
                        " type="text" :id="`input-growup-${popover.langRecognition.toLowerCase()}-${index}`" v-model="value.names[popover.langRecognition.toLowerCase()]" @input="(event) => onInputRecognitionModel(event, index)
    " />
                      <span class="ml-12 fs-16 cursor-pointer icon-close" @click="removeRecognitionTag(value.value)"><i
                          class="el-icon-close" style="font-weight: 700"></i></span>
                      <span class="span-growup" :id="`span-growup-${popover.langRecognition.toLowerCase()}-${index}`"></span>
                      <div class="popup">
                        <div class="fs-10 fw-700">DEFAULT</div>
                        <div class="fs-12 opa-07">{{ value.label }}</div>
                      </div>
                    </div>
                  </draggable>
                  <div class="mt-12 flex-center">
                    <span class="
                        recognition-tags
                        flex-center
                        disable
                        cursor-default
                      ">
                      <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                      <span class="">New Value</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="line-style mt-24" />
            <div class="flex">
              <div>
                <div ref="peer-feedbak" class="header-text mt-24">
                  Peer Feedback
                </div>
                <div class="description-text">
                  At the beginning of each month, each member will be able to
                  select up to 2 people to receive feedback from. When giving
                  feedback, reviewers can assign the following tags that
                  represent what the recipient “excels” at:
                </div>
              </div>
              <el-popover placement="bottom" title="Languages" width="180" trigger="click" class="mt-24 ml-auto"
                v-model="popover.visiblePeerFeedback" v-if="settingData.peerFeedbackInteractions_checked && multiLang">
                <div v-for="val in language" :key="val.code" class="select-lang in-popover flex-center" @click="setLanguage('peerFeedback', val.code.toUpperCase())">
                    
                    {{val.text}}
                    
                </div>
                <!-- <div>
                  <div class="select-lang in-popover flex-center" @click="setLanguage('peerFeedback', 'EN')">
                    English (Default)
                  </div>
                  <div class="select-lang in-popover flex-center" @click="setLanguage('peerFeedback', 'TH')">
                    TH - ไทย
                  </div>
                </div> -->
                <el-button type="text" slot="reference" class="lang-button">
                  <div class="flex-mid pl-8 pr-12">
                    <img :src="$utils('icons', 'flag_purple_20dp')" alt="icons_flag_purple_20dp" />
                    <div class="ml-auto">
                      {{ popover.langPeerFeedback }}
                    </div>
                  </div>
                </el-button>
              </el-popover>
            </div>
            <div class="flex-center mt-24">
              <div class="switch mr-16">
                <div class="can-toggle">
                  <input class="input" type="checkbox" id="peerFeedbackInteractions_checked"
                    v-model="settingData.peerFeedbackInteractions_checked" />
                  <label for="peerFeedbackInteractions_checked" :class="`${settingData.peerFeedbackInteractions_checked
                    ? 'power-on'
                    : 'power-off'
                    }`">
                    <div class="switch-body flex-mid">
                      <div v-if="settingData.peerFeedbackInteractions_checked" class="mr-auto ml-14 mt-2">
                        ON
                      </div>
                      <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                    </div>
                  </label>
                </div>
              </div>
              <span class="fc-4A4A4A fs-14 fw-700">Peer Feedback Interactions</span>
            </div>
            <div :class="`setting-row ${settingData.peerFeedbackInteractions_checked
              ? 'mt-24'
              : 'expand-setting'
              }`" :style="`margin-left: 7px; height: ${!settingData.peerFeedbackInteractions_checked
    ? 0
    : uiSetting.peerFeedbackInteractions_checked_row
    }px;`">
              <div ref="peerFeedbackInteractions_checked_row">
                <div v-if="popover.langPeerFeedback == 'EN'">
                  <div class="flex-center flex-wrap" style="gap: 12px 0">
                    <span v-for="values in peerFeedbackExcels" :key="values.key" class="peer-feedback-tags flex-center">
                      <span>{{ values.name }}</span>
                      <span class="ml-12 fs-16 cursor-pointer" @click="removePeerFeedbackTag(values.key)"><i
                          class="el-icon-close" style="font-weight: 700"></i></span>
                    </span>
                  </div>
                  <div class="mt-12 flex-center" style="flex-wrap: wrap; gap: 12px 0">
                    <span @click="showPeerFeedbackInput" v-if="!savePeerFeedbackInput"
                      class="peer-feedback-tags flex-center cursor-pointer">
                      <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                      <span class="">New Excel Tag</span>
                    </span>
                    <input class="peer-feedback-tags input" v-if="savePeerFeedbackInput" style="height: 18px"
                      v-model="savePeerFeedbackValue" ref="savePeerFeedbackInput"
                      @keyup.enter="handleInputPeerFeedbackConfirm" @blur="handleInputPeerFeedbackConfirm" />
                  </div>
                </div>
                <div v-else>
                  <div class="flex-wrap" style="gap: 12px 0px">
                    <div v-for="(value, index) in peerFeedbackExcels" :key="value.key + '_input'" class="relative">
                      
                      <input class="peer-feedback-tags input-growup" :style="`${$utils(
                        'fontStyle',
                        value.name_th
                      )} !important;'`" type="text" :id="`input-peer-growup-${popover.langPeerFeedback.toLowerCase()}-${index}`" v-model="value.names[popover.langPeerFeedback.toLowerCase()]" @input="(event) => onInputPeerFeedbackModel(event, index)
  " />
                      <span class="ml-12 fs-16 cursor-pointer icon-close" @click="removePeerFeedbackTag(value.key)"><i
                          class="el-icon-close" style="font-weight: 700"></i></span>
                      <span class="span-growup" :id="`span-peer-growup-${popover.langPeerFeedback.toLowerCase()}-${index}`"></span>
                      <div class="popup">
                        <div class="fs-10 fw-700">DEFAULT</div>
                        <div class="fs-12 opa-07">{{ value.name }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-12 flex-center">
                    <span class="
                        peer-feedback-tags
                        flex-center
                        disable
                        cursor-default
                      ">
                      <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                      <span class="">New Excel Tag</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="line-style mt-32" />
            <div ref="happily-village" class="header-text mt-24">
              Happily Village
            </div>
            <div class="description-text">
              All members will have access to a Happily Village with
              interactions that will promote wellness, learning, and
              collaboration with a Running Track, University, Houses, and more!
            </div>
            <div class="flex-center mt-24">
              <div class="switch mr-16">
                <div class="can-toggle">
                  <input class="input" type="checkbox" id="happilyVillageAccess_checked"
                    v-model="settingData.happilyVillageAccess_checked" />
                  <label for="happilyVillageAccess_checked" :class="`${settingData.happilyVillageAccess_checked
                    ? 'power-on'
                    : 'power-off'
                    }`">
                    <div class="switch-body flex-mid">
                      <div v-if="settingData.happilyVillageAccess_checked" class="mr-auto ml-14 mt-2">
                        ON
                      </div>
                      <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                    </div>
                  </label>
                </div>
              </div>
              <span class="fc-4A4A4A fs-14 fw-700">Happily Village Access</span>
            </div>

            <div class="line-style mt-24" />
          <div class="header-text mt-24">
            <div class="header-text">Happily Assistance</div>
            <div class="description-text">
              Allow the Happily team access to your console to assist with
              account management and recommendations.
            </div>
            <div class="flex-center mt-18">
              <div class="switch mr-16">
                <div class="can-toggle">
                  <input class="input" type="checkbox" id="happilyAssistAccess_checked"
                    v-model="settingData.happilyAssistAccess_checked" />
                  <label for="happilyAssistAccess_checked" :class="`${settingData.happilyAssistAccess_checked
                    ? 'power-on'
                    : 'power-off'
                    }`">
                    <div class="switch-body flex-mid">
                      <div v-if="settingData.happilyAssistAccess_checked" class="mr-auto ml-14 mt-2">
                        ON
                      </div>
                      <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                    </div>
                  </label>
                </div>
              </div>
              <span class="fc-4A4A4A fs-14 fw-700">Happily Assist Access</span>
            </div>
          </div>
          <div class="line-style mt-32" />
            <div class="header-text mt-24">Demo Mode</div>
            <div class="description-text">
              Usernames, emails, teams and profile images associated with existing members 
              are blurred across all pages when demo mode is turned on. Use with discretion
              - some elements may not be completely censored.
            </div>
            <div class="mt-24 fc-4A4A4A fs-14 fw-700">Windows:
              <span class="key">Ctrl</span><span class="key">Alt</span> <span class="key">D</span> or
              <span class="key">⊞</span> <span class="key">Alt</span><span class="key">D</span></div>
            <div class="mt-24 fc-4A4A4A fs-14 fw-700">Mac: 
              <span class="key">control</span><span class="key">option</span><span class="key">D</span> or
              <span class="key">⌘</span><span class="key">option</span><span class="key">D</span></div>
          </div>

          

        </el-form>
      </div>
    </div>

    <!-- Modal Holiday Presets -->
    <el-dialog :visible.sync="showModal_holiday_presets" :before-close="closeModalHolidayPresets" width="1100px"  top="8vh">
            <div class="flex-center" style="background-color:#F8F8F8;">
              <div class="modal-1" style="width:640px; "> 
                <div  class="flex-column" style="margin-top: 40px;">
                    <div class="flex-center" style="justify-content: space-between;">
                    <div class="flex-column">
                      <span class="fs-20 fw-700 mb-8" style="color: #000;">
                        Holiday Presets
                      </span>
                      <div class="opa-06">
                        Manage when daily pulse questions should not be delivered
                      </div>

                    </div>
                
                    <el-button style="width:133.7px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;margin-right: 32px;padding: 0px;" @click="createPreset">
                      <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                        <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                          <path d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z"/>
                        </svg>
                        <span>Create Preset</span>
                      </div>
                    </el-button>

                    </div>
                    <div class="fs-16 fw-700 pt-32 fc-323232" style="margin-top: 20px;">My Presets Library</div>
                    <div>
                    <el-input class="input-style mb-32 mt-12 " style="font-size: 15px; width: 260px !important" autosize
                      :placeholder="$t('global.Search')"  v-model="inputSearch_preset" clearable></el-input>
                    </div>
                    <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loading_preset">
                      <loading-even></loading-even>
                    </div>

                    <div v-else>
                      <!-- card -->
                      <div v-for="(item,index) in presetlist" :key="index" class="mb-8 cursor-pointer" :class="`${item.focus_preset?'preset-focus':'preset-library'}`" @click="ClickEditPresets(index)">
                        <div class="flex-center" style="justify-content: left;">
                      
                          <div class="flex-center" style="width: 396px;">
                            <div class="flex-center" :style="`justify-content: center;background:${item.focus_preset?'#EEE5FD':'#EDEDED'} 0% 0% no-repeat padding-box;border-radius: 12px;width: 52px;height: 52px;color:${item.focus_preset?'#6C30CC':'#000'}`">{{ item.total_assignments }}</div>
                            <div class="flex-column" style="margin-left: 16px;">
                              <span class="fs-15 fw-700 fc-2E2E2E" >{{ item.name }}</span>
                              <span class="fs-13 fc-2E2E2E mt-4" >{{gettextAssigned((item.teams?item.teams.length:0), (item.users?item.users.length:0))}}</span>
                            </div>
                          </div>
                          <div class="flex-center" style="justify-content: space-between;width:205px;">
                            
                            <div class="fs-12 fc-2E2E2E" >{{ item.total_assignments }} assignments total</div>
                            <div class="arrow-right">
                              <svg xmlns="http://www.w3.org/2000/svg" width="10.477" height="20" viewBox="0 0 10.477 20">
                                <path id="Path_40066" data-name="Path 40066" d="M102.335,54.335l-9.524,9.524a.476.476,0,1,1-.674-.674L101.324,54l-9.187-9.187a.476.476,0,0,1,.674-.674l9.524,9.524a.476.476,0,0,1,0,.674" transform="translate(-91.998 -43.998)"/>
                              </svg>
                            </div>

                          </div>


                        </div>
                        


                      </div>

                    </div>




                  </div>
        
                    




              
                </div>

                <div class="modal-2" style="width:460px;">

                  <div v-if="status_show_preset_forms" class="flex-center" style="justify-content: center;height: 100%;text-align: center;">
                    <div class="fs-16 fw-700" style="color: #000;opacity: 0.4;">Create a Holiday Preset to disable daily pulse questions on a person’s day off</div>
                  </div>
                  <div v-else>
                    
                  
                    <div class="flex-column" style="margin-top: 40px;">
                      <div class="fs-20 fw-700" style="color: #000;">{{ title_preset }}</div>
                      <div class="fs-14 fw-700 pt-24">Preset Name</div>
                      <div v-if="presetForm_verify.name==true" class="validate-worming-data">
                        <el-input class="input-style mt-8"  style="font-size: 15px; width: 376px !important;" autosize
                        placeholder="Enter preset name"  v-model="presetForm.name"></el-input>
                        <div class="validate-worming-data-text ">
                          Please enter a preset name
                        </div>
                      </div>
                      <div v-else>
                        <el-input class="input-style mt-8" style="font-size: 15px; width: 376px !important;" autosize
                        placeholder="Enter preset name"  v-model="presetForm.name"></el-input>

                      </div>
                      
                    </div>

                    <div class="fs-14 fw-700 pt-16 pb-16">Day Off in the Week</div>

                      <el-checkbox-group
                        v-model="presetForm.dayoff"
                        @change="handleCheckedDayChange"
                      >
                        <el-checkbox v-for="day in dayofweek" :key="day" :label="day" :value="day" class='flex-column fs-13 fw-700 mb-15' style="width: 100%;">
                          {{ day }}
                        </el-checkbox>
                      </el-checkbox-group>

                      <div class="flex-center pt-8">
                        <div class="switch mr-16">
                          <div class="can-toggle">
                            <input class="input" type="checkbox" id="company_holiday"
                              v-model="presetForm.company_holiday" />
                            <label for="company_holiday" :class="`${presetForm.company_holiday
                              ? 'power-on'
                              : 'power-off'
                              }`">
                              <div class="switch-body flex-mid">
                                <div v-if="presetForm.company_holiday" class="mr-auto ml-14 mt-2 fs-13">
                                  ON
                                </div>
                                <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                                
                              </div>
                         
                            </label>
                          </div>
                        </div>
                        <span class="fc-4A4A4A fs-14">Also Apply Company Holidays</span>
                      </div>

                      <div class="flex-center mb-12" style="justify-content: space-between;">
                        <div class="fs-16 fw-700 pt-32">Assign to Teams</div>
                        <div class="fs-14 pt-32 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('team')"> + Add Teams</div>
                      </div>
                      <div v-for="team in presetForm.team" :key="team.id+'team'" class="mb-8">
                        <div class="flex-center" style="justify-content: left;padding: 16px 6px 16px 12px;background: #F5EFFF 0% 0% no-repeat padding-box;">
                          <div class="flex-center" style="width: 376px;">
                            <div class="fs-16 fw-500 pl-16 fc-323232" style="color: #000;opacity: 1;">{{ team.name }}</div>
                            <div class="fs-13 pl-10 fc-908D95">{{ team.membersteams }} members</div>
                          </div>
                          <div class="pr-16 cursor-pointer" @click="deleteTeam(team.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                              <g id="Close" transform="translate(0.354 0.354)">
                                <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                                <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>

                      <div class="flex-center mt-21 mb-12" style="justify-content: space-between;">
                        <div class="fs-16 fw-700 pt-16">Assigned Members</div>
                        <div class="fs-14 pt-16 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('member')"> + Add Member</div>
                      </div>
                      <div v-for="users in presetForm.users" :key="users.email+'members'" class="mb-8">
                        <div class="flex-center" style="justify-content: left;padding: 8px 6px 8px 12px;background: #F5EFFF 0% 0% no-repeat padding-box;">
                          <div class="flex-column" style="width: 376px;">
                            <div class="fs-16 fw-500 pl-16 fc-323232" style="color: #000;opacity: 1;">{{ users.firstname }} {{ users.lastname }}</div>
                            <div class="fs-13 pl-16 fw-400 fc-9D9D9D mt-2">{{ users.team_name }}</div>
                          </div>
                          <div class="pr-16 cursor-pointer" @click="deleteUser(users.email)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                              <g id="Close" transform="translate(0.354 0.354)">
                                <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                                <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>



                    <div v-if="popup_preset.show" class="warning-popup-1">
                      <div class="body flex-center" style="width: 368px;justify-content: space-between;">
                        <div class="fs-500 fc-FFFFFF fs-14">
                          {{popup_preset.title}}
                        </div>
                        <div v-if="popup_preset.status=='update'"><el-button style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color:#F44336;width:54px;height:32px;font:13px;" @click="deletePreset">{{popup_preset.button_left}}</el-button>
                        <el-button v-if="popup_preset.button_right" style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:92px;height:32px;font:13px" @click="savePreset">{{popup_preset.button_right}}</el-button>
                        </div>
                        <div v-else>
                          <el-button style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #6c30cc;width:62px;height:32px;font:13px;" @click="clearData">{{popup_preset.button_left}}</el-button>
                        <el-button  style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:104px;height:32px;font:13px" @click="savePreset">{{popup_preset.button_right}}</el-button>
                        </div>
                        
                      
                        
                      </div>
                    </div>
                    
                    

                 
                </div>



                
                



                    
              </div>
              

            </div>

    </el-dialog>

     <!-- Add Member and Team -->
     <el-dialog :visible.sync="addMemberTeam" :before-close="cancelselectedTeamandMember"  width="1020px" >
        <div class="flex-center" style="background-color:#F8F8F8;">
          <div class="modal-1" style="width:320px;background: #F8F8F8 0% 0% no-repeat padding-box !important;">
            <div class="fs-20 fc-2D2E36 fw-700 pt-44 pb-25">{{addMemberTeamForm.type=='team'?selected_team.length:selected_user.length}} {{ addMemberTeamForm.title_left }}</div>

            <div v-if="addMemberTeamForm.type=='team'">
              <div v-for="team in selected_team" :key="`${team.id}_select_team`" class="fs-14 fc-4A4A4A fw-700 pb-16">
              <div class="flex-center" style="justify-content: space-between;">


                <div class="flex-center" style="justify-content: left;">
                  <img  style="width: 42px;height: 42px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;">
                  <div>
                    <div class="fs-14 fc-4A4A4A fw-600">{{team.name}}</div>
                    <div class="fs-14 fw-400 fc-9D9D9D">{{team.membersteams}} members</div>
                  </div>
                </div>


                <div class="pr-32 cursor-pointer" @click="deleteTeam(team.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                    <g id="Close" transform="translate(0.354 0.354)">
                      <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                      <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                    </g>
                  </svg>
                </div>

              </div>

              

              </div>
            </div>
            <div v-else>
              <div v-for="user in selected_user" :key="`${user.email}`" class="fs-14 fc-4A4A4A fw-700 pb-16">
              <div class="flex-center" style="justify-content: space-between;">


                <div class="flex-center" style="justify-content: left;">
                  <img  :src="user.profilepic_crop" style="width: 42px;height: 42px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;">
                  <div>
                    <div class="fs-14 fc-4A4A4A fw-600">{{user.firstname}} {{user.lastname}}</div>
                    <div class="fs-14 fc-908D95 fw-400">{{user.team_name}}</div>
                  </div>
                </div>


                <div class="pr-16 cursor-pointer" @click="deleteUser(user.email)">
                  <img :src="$utils('icons', 'x-16x16px')" style="width: 16px;height: 16px;">
                </div>

              </div>

              

              </div>


            </div>
          </div>

          <div class="modal-2" style="width:700px;background: #FFFFFF 0% 0% no-repeat padding-box !important;overflow-y: hidden !important;overflow-x: hidden !important;">
            
            <div class="flex-column" style="justify-content: space-between;">
              <div class="fs-24 fw-700 pt-40" style="color: #2D2E36;">{{addMemberTeamForm.title}}</div>
              <div>
                <el-input v-model="searchmemberandteamandMember" style="width: 300px;" :placeholder="addMemberTeamForm.placeholder" class="w-100 pt-32"></el-input>
              </div>
              <div class="fs-14 fc-908D95 pt-24 pb-20">Results based on the search terms…</div>
              <div>

                <div v-if="addMemberTeamForm.type=='team'">


                  <div class="flex-center" style="justify-content: left; width: 700px;flex-wrap: wrap;margin-right: 40px;max-height: 550px;overflow-y: auto;">
                    <div v-for="(index,id) in addMemberTeamForm.team" :key="addMemberTeamForm.team[id].id"  :class="addMemberTeamForm.team[id].statusClick?'border-blue':''" class="selection-cell" @click="selectedTeamAndMember(id,'team')">
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <div style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;"></div>
                          <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                            <img  style="width: 40px;height: 40px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;margin-left: 16px;">
                            <div class="flex-column">
                              <div class="fs-14 fc-4A4A4A fw-700">{{addMemberTeamForm.team[id].name}}</div>
                              <div class="fs-14 fc-9D9D9D">{{addMemberTeamForm.team[id].users.length}} members</div>
                          </div>
                          </div>


                        </div>


                      
                      
                    
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="flex-center" style="justify-content: left; width: 700px;flex-wrap: wrap;margin-right: 40px;max-height: 550px;overflow-y: auto;">
                    <div v-for="(index,id) in addMemberTeamForm.user" :key="addMemberTeamForm.user[id].email"  :class="addMemberTeamForm.user[id].statusClick?'border-blue':''" class="selection-cell" @click="selectedTeamAndMember(id,'user')">
                    
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <div style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;"></div>
                          <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                            <img :src="addMemberTeamForm.user[id].profilepic_crop" style="width: 40px;height: 40px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;margin-left: 16px;">
                            <div class="flex-column">
                              <div class="fs-14 fc-4A4A4A fw-700">{{addMemberTeamForm.user[id].firstname}} {{addMemberTeamForm.user[id].lastname}}</div>
                              <div class="fs-14 fc-9D9D9D">{{addMemberTeamForm.user[id].team_name}}</div>
                          </div>
                          </div>


                        </div>


                      
                      
                    
                    </div>
                  </div>



                </div>

             


              <div class="flex-center" style="justify-content: right; margin-top: 20px;">
                <el-button type="primary" style="width: 122px;height: 50px;background: #D1D1D1 0% 0% no-repeat padding-box;
                  border: none;" @click="cancelselectedTeamandMember">CANCEL</el-button>
                <el-button type="primary"style="width: 120px;height: 50px;background: #32C2D5 0% 0% no-repeat padding-box;
                  border: none;" @click="submitselectedTeamandMember">SUBMIT</el-button>
              </div>
                
              </div>


              
            </div>


    
                
          </div>
          

        </div>

      </el-dialog>

            <!-- Submit member or team -->

      <el-dialog
        :visible.sync="confirm_add_dialog"
        width="650px" center style="max-height: 600px;min-height: 300px;"
        :before-close="handleClose"
      >
      
        <div class="flex-column" style="height: 300px;max-height: 300px;">
          <div class="fs-16 fc-908D95 fw-700" style="margin-top: 50px;margin-left: 30px;">{{ `Some selected ${addMemberTeamForm.type=='member'?'members':'teams'} have existing preset assignments` }}</div>
       
            <div v-for='(text,index) in text_confirm' :key="`${index}_text`" style="margin-top: 20px;margin-left: 30px;overflow-y: scroll;max-height: 300px;">
              {{ text }}
            </div>
            <div style="margin-top: 20px;margin-left: 30px;">Proceeding will override their existing preset assignments. Would you like to continue?</div>
         
        </div>
        <template>
          <div class="flex-center" style="justify-content: right;padding-bottom: 30px;padding-right: 30px;">
            <el-button @click="handleClose">Cancel</el-button>
            <el-button type="primary" @click="confirm_Add">
              Confirm
            </el-button>
          </div>
        </template>
       
      </el-dialog>



  </div>
</template>

<script>
import format from "date-fns/format";
import firebase from "firebase/app";
import "firebase/database";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
    loadingEven: require("./even/loading").default,
  },

  name: "settings",
  watch: {
    settingData: {
      handler() {
        this.handlerHeightOfSetting();
      },
      deep: true,
    },
    recognitionValue: {
      handler() {
        this.handlerHeightOfSetting();
      },
      deep: true,
    },
    peerFeedbackExcels: {
      handler() {
        this.handlerHeightOfSetting();
      },
      deep: true,
    },
    async searchmemberandteamandMember() {
      //console.log("searchmemberandteam",this.searchmemberandteamandMember)
      await this.$store.dispatch("settings/searchmemberandteamandMember", {value:this.searchmemberandteamandMember,type:this.addMemberTeamForm.type})
      if(this.addMemberTeamForm.type=='team'){
        this.addMemberTeamForm.team=[]
        for(const key in this.memberInteam){
          const _team=_.find(this.selected_team,{name:this.memberInteam[key].name})
          if(_team){
            this.addMemberTeamForm.team.push({key:key,statusClick:true,...this.memberInteam[key]})
          }else{
            this.addMemberTeamForm.team.push({key:key,statusClick:false,...this.memberInteam[key]})
          }
          
        }
      }
      else{
        this.addMemberTeamForm.user=[]
        for(const key in this.member){
           //console.log('this.member',this.member[key])
          const _member=_.find(this.selected_user,{email:this.member[key].email})
          if(_member){
            this.addMemberTeamForm.user.push({key:key,statusClick:true,...this.member[key]})

          }else{
            this.addMemberTeamForm.user.push({key:key,statusClick:false,...this.member[key]})
          }
          
        }
      }
    },
    inputSearch_preset: {
      handler(newVal) {
        //console.log('newVal',newVal)
        this.$store.dispatch("settings/searchData_preset", newVal)
        //this.searchmemberandteam()
      },
      deep: true
    },

    presetForm: {
      handler(newVal) {
        this.checkedChanges()
        
      },
      deep: true 
    },
  },
  data() {
    return {
      dynamicTags: [
        "Leadership",
        "Initiative",
        "Clarity",
        "Timely",
        "Creativity",
        "Teamwork",
      ],
      saveRecognitionInput: false,
      saveRecognitionValue: "#",
      savePeerFeedbackInput: false,
      savePeerFeedbackValue: "",
      recognitionOldValue: [],
      uiSetting: {
        medalsForLeaders_checked_row: 0,
        recognitionValue_checked_row: 0,
        peerFeedbackInteractions_checked_row: 0,
      },
      setingChanged: false,
      popover: {
        visibleMedal: false,
        langMedal: "EN",
        visibleRecognition: false,
        langRecognition: "EN",
        visiblePeerFeedback: false,
        langPeerFeedback: "EN",
      },
      recognitionDataSetting: [
        {
          label_th: "test1",
          label_en: "ทดสอบ1",
          id: "test1",
        },
        {
          label_th: "test2_test2",
          label_en: "ทดสอบ2_test2",
          id: "test2",
        },
        {
          label_th: "test3",
          label_en: "ทดสอบ3",
          id: "test3",
        },
      ],
      overdueMonths: [2, 3, 4, 5, 6],
      dayofweek:['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
      showModal_holiday_presets: false,
      inputSearch_preset: '',
      status_show_preset_forms:true,
      title_preset:'',
      presetForm:{
        preset_id:'',
        name: '',
        dayoff: [],
        company_holiday: true,
        team:[],
        user:[],

      },
      presetForm_old:{
        preset_id:'',
        name: '',
        dayoff: [],
        company_holiday: true,
        team:[],
        user:[],
      },
      popup_preset:{
        show:false,
        title:'',
        content:'',
        button_left:'',
        button_right:'',
      },
      presetForm_verify:{
        name:  false,
      },
      addMemberTeam:false,
      addMemberTeamForm:{
        title_left:'',
        type:'',
        title:'',
        description:'',
        team:[],
        user:[],
        selected:[],
        placeholder:''
      },
      selected_team:[],
      selected_user:[],
      searchmemberandteamandMember:'',
      confirm_add_dialog:false,
      text_confirm:[],
      status_edit_preset:false,
      index_focus:'',
    };
  },

  created() {
    // this.$store.dispatch("settings/getoldExcelsByCompany");
    this.$store.dispatch("settings/checkEngOnly", this.user);
    this.$store.dispatch("settings/getDataSetting", this.user);
    // this.$store.dispatch("settings/getExcelsByCompany");
    this.$store.dispatch("settings/getoldDataSetting", this.user);
    this.$store.dispatch("member/getMember", this.user);
    this.$store.dispatch("settings/getmemberInteam", this.user);
    

    //this.oldRecognitionValue = [...this.recognitionValue];
  },
  mounted() {
    this.handlerHeightOfSetting();
    this.handlerHeightOfSetting(1000);
    this.goto();
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    settingData() {
      return this.$store.getters["settings/setting"];
    },
    countAll() {
      return this.$store.getters["member/countAll"];
    },
    peerFeedbackExcels() {
      return this.$store.getters["settings/excels"];
    },
    hashTagId() {
      return this.$store.getters["settings/hashTagId"];
    },
    settingOldDataMock() {
      return this.$store.getters["settings/settingOldDataMock"];
    },
    oldRecognitionValue() {
      return this.$store.getters["settings/oldRecognitionValue"];
    },
    recognitionValue: {
      get() {
        return this.$store.getters["settings/recognitionValue"];
      },
      set(newValue) {
        this.$store.commit("settings/setRecognitionValue", newValue);
      },
    },
    multiLang() {
      return this.$store.getters["settings/multiLang"];
    },
    oldExcels() {
      return this.$store.getters["settings/oldExcels"];
    },
    language(){
      return this.$store.getters["settings/language"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    member(){
      return this.$store.getters["settings/member"];
    },
    memberInteam(){
      return this.$store.getters["settings/memberinteam"];
    },    
    presetlist(){
      return this.$store.getters["settings/presetlist"];
    },
    presetlistAll(){
      return this.$store.getters["settings/presetlistAll"];
    },
    loading_preset(){
      return this.$store.getters["settings/loading_preset"];
    },
  },
  methods: {
    updateCradList(event) {
      this.recognitionValue = this.arrayMovePosition(
        this.recognitionValue,
        event.oldIndex,
        event.newIndex
      );
    },
    arrayMovePosition(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    },
    goto() {
      const hash = this.$router.currentRoute.hash.split("#")[1];
      var element = this.$refs[hash];
      if (element) {
        const top = element.offsetTop;
        window.scrollTo(0, top + 230);
      }
      if (element) {
        this.$refs[hash].scrollTop = 0 + 230;
      }
    },
    handlerHeightOfSetting(time) {
      let wait = 50;
      if (time) {
        wait = time;
      }
      setTimeout(() => {
        this.checkedChanges();
        this.matchHeight();
      }, wait);
    },
    showRecognitionInput() {
      this.saveRecognitionInput = true;
      this.$nextTick((_) => {
        this.$refs.saveRecognitionInput.focus();
      });
      this.handlerHeightOfSetting(150);
    },
    showPeerFeedbackInput() {
      this.savePeerFeedbackInput = true;
      this.$nextTick((_) => {
        this.$refs.savePeerFeedbackInput.focus();
      });
      this.handlerHeightOfSetting(150);
    },
    async handleInputRecognitionConfirm() {
      let _recognitionValue = this.recognitionValue;
      await this.$store.dispatch("settings/newIdhashtag");
      const saveRecognitionValue = this.saveRecognitionValue;
      if (saveRecognitionValue !== "#") {
        _recognitionValue.push({
          value: this.hashTagId,
          label: saveRecognitionValue,
          labelTh: "#",
        });
        this.recognitionValue = _recognitionValue;
      }
      this.saveRecognitionInput = false;
      this.saveRecognitionValue = "#";

      this.handlerHeightOfSetting(150);
    },
    async handleInputPeerFeedbackConfirm() {
      let peerFeedbackExcels = this.peerFeedbackExcels;
      const savePeerFeedbackValue = this.savePeerFeedbackValue;
      let language={}
        for(const i in this.language){
            if(!language[this.language[i].code]){
              language[this.language[i].code]=savePeerFeedbackValue
            }
        }
      const _language=_.clone(language)
      let newid=firebase.database().ref(`/excels_company/${this.user.company}`).push().key;
      
      // await this.$store.dispatch("settings/newIdhashtag");
      
      if (savePeerFeedbackValue !== "") {
      
        peerFeedbackExcels.push({
          // value: `rand-${Math.floor(Math.random() * 999999)}`,
          // label:savePeerFeedbackValue,
          name: savePeerFeedbackValue,
          name_th: savePeerFeedbackValue,
          names:_language,
          status: "Y",
          updated: format(new Date(), "YYYY-MM-DD HH:mm"),
          createdate: format(new Date(), "YYYY-MM-DD HH:mm"),
          key: newid,
        });
        this.$store.commit("settings/setExcels", peerFeedbackExcels);
        //this.peerFeedbackExcels = peerFeedbackExcels;
      }
      this.savePeerFeedbackInput = false;
      this.savePeerFeedbackValue = "";

      this.handlerHeightOfSetting(150);
    },
    removeRecognitionTag(id) {
      if (id) {
        this.recognitionValue = this.recognitionValue.filter((obj) => {
          return obj.value !== id;
        });
      }
      this.handlerHeightOfSetting(150);
    },
    removePeerFeedbackTag(id) {
      if (id) {
        let peerFeedbackExcels = {};
        peerFeedbackExcels = this.peerFeedbackExcels.filter((obj) => {
          return obj.key !== id;
        });
        this.$store.commit("settings/setExcels", peerFeedbackExcels);
      }
      this.handlerHeightOfSetting(150);
    },
    saveChanges() {
      if (
        !this.settingData.starttime ||
        !this.settingData.report_dailyboss_time ||
        !this.settingData.report_weeklyboss_time ||
        !this.settingData.Creativity.replace(/ /g, "") ||
        !this.settingData.Initiative.replace(/ /g, "") ||
        !this.settingData.Kindness.replace(/ /g, "") ||
        !this.settingData.Strength.replace(/ /g, "") ||
        !this.settingData.Charisma.replace(/ /g, "") ||
        !this.settingData.Intelligence.replace(/ /g, "")
      ) {
        this.$message({
          showClose: true,
          message: "Valid Data required.",
          type: "error",
        });
      } else {
        var messageLoading = this.$message({
          type: "warning",
          message: "Saving changes...",
          duration: "9999000",
        });
        this.$store
          .dispatch("settings/saveChanges", {
            id: this.id,
            form: this.settingData,
            recognitionValue: this.recognitionValue,
            company: this.user.company,
            countMembers: this.countAll,
            thisvue: this,
            messageLoading: messageLoading,
            excels: this.peerFeedbackExcels,
          })
          .then(() => {
            setTimeout(() => {
              this.$store.dispatch("settings/getDataSetting", this.user);
              this.$store.dispatch("settings/getoldDataSetting", this.user);
            }, 1000);
          });
      }
    },
    showDatepickerHoliday() {
      this.$refs.datepicker_holiday.focus();
    },
    confirmHolidayDatepicker() {
      let tag = [];
      let val = [];
      if (
        this.settingData["holiday_val"] &&
        this.settingData["holiday_val"].length > 0
      ) {
        let data = _.orderBy(this.settingData["holiday_val"]);
        for (const i in data) {
          tag.push(format(data[i], "dddd, MMMM D, YYYY"));
          val.push(data[i]);
        }
      }
      this.settingData["holiday_tag"] = tag;
      this.settingData["holiday_val"] = val;
    },
    removeTag(index) {
      this.settingData["holiday_tag"].splice(index, 1);
      this.settingData["holiday_val"].splice(index, 1);
    },
    getPaddingStyle(data) {
      if (data && data.length > 0) {
        return "12px";
      } else {
        return "20px";
      }
    },
    refresh() {
      localStorage.userVersion = localStorage.appVersion;
      location.reload(true);
      this.goto();
    },
    checkedChanges() {
      const settingData = _.isArray(this.settingOldDataMock) ? true : 
        _.isEqual(this.settingData, this.settingOldDataMock);
      const excels = _.isEqual(this.peerFeedbackExcels, this.oldExcels);
      const recognitionValue = _.isEqual(
        this.recognitionValue,
        this.oldRecognitionValue
      );
      if (!settingData || !recognitionValue || !excels) {
        this.setingChanged = true;
      } else {
        this.setingChanged = false;
      }
    },
    undoSaveSetting() {
      if (this.settingOldDataMock.performance_review) {
        this.pendingAfterChange(_.get(this.settingOldDataMock, "performance_review.pending"));
      }
      this.$store.commit("settings/setDataSetting", this.settingOldDataMock);
      this.$store.commit("settings/setExcels", this.oldExcels);
      this.recognitionValue = [...this.oldRecognitionValue];
      this.$store.dispatch("settings/getDataSetting", this.user);
      this.$store.dispatch("settings/getoldDataSetting", this.user);
      this.$store.dispatch("settings/getExcelsByCompany");
      this.$store.dispatch("settings/getoldExcelsByCompany");
      this.checkedChanges();
    },
    matchHeight() {
      if (this.$refs.medalsForLeaders_checked_row) {
        this.uiSetting.medalsForLeaders_checked_row =
          this.$refs.medalsForLeaders_checked_row.clientHeight;
      }
      if (this.$refs.recognitionValue_checked_row) {
        setTimeout(() => {
          if (this.$refs.recognitionValue_checked_row.clientHeight > 73) {
            this.uiSetting.recognitionValue_checked_row =
              this.$refs.recognitionValue_checked_row.clientHeight;
          } else {
            this.uiSetting.recognitionValue_checked_row = 74;
          }
        }, 100);
      }
      if (this.$refs.peerFeedbackInteractions_checked_row) {
        setTimeout(() => {
          this.uiSetting.peerFeedbackInteractions_checked_row =
            this.$refs.peerFeedbackInteractions_checked_row.clientHeight;
        }, 120);
      }
    },
    setLanguage(value, lang) {
      switch (value) {
        case "medals":
          this.popover.visibleMedal = false;
          this.popover.langMedal = lang;
          break;
        case "recognition":
          this.updateAllContentRecognition();
          this.popover.visibleRecognition = false;
          this.popover.langRecognition = lang;
          break;
        case "peerFeedback":
          this.updateAllContentPeerFeedback();
          this.popover.visiblePeerFeedback = false;
          this.popover.langPeerFeedback = lang;
          break;
      }
      this.handlerHeightOfSetting();
    },
    onInputRecognition(event, index) {
      const labelTh = event.target.innerText;
      this.recognitionValue[index].labelTh = labelTh;
    },
    onRemoveRecognition(index) {
      if (
        this.recognitionValue.length > 1 &&
        this.recognitionValue[index].labelTh.length === 0
      ) {
        this.updateAllContentRecognition();
      }
    },
    updateAllContentRecognition() {
      this.peerFeedbackExcels.forEach((c, index) => {
        const el = document.getElementById(`peerFeedbackExcels-${index}`);
        if (c.labelTh && el) {
          el.innerText = c.labelTh;
        }
      });
    },
    onInputPeerFeedback(event, index) {
      const name_th = event.target.innerText;
      this.peerFeedbackExcels[index].name_th = name_th;
    },
    onRemovePeerFeedback(index) {
      if (
        this.peerFeedbackExcels.length > 1 &&
        this.peerFeedbackExcels[index].name_th.length === 0
      ) {
        this.updateAllContentPeerFeedback();
      }
    },
    updateAllContentPeerFeedback() {
      this.peerFeedbackExcels.forEach((c, index) => {
        const el = document.getElementById(`peerFeedbackExcels-${index}`);
        if (c.name_th && el) {
          el.innerText = c.name_th;
        }
      });
    },
    widthOfBox(text) {
      if (text) {
        if (text.length > 5 && text.length < 80) {
          return "";
        }
      }
      return "display: inline-block;";
    },
    onInputRecognitionModel(event, index) {
      const el = document.getElementById(`input-growup-${index}`);
      const span = document.getElementById(`span-growup-${index}`);
      el.addEventListener("input", function (event) {
        span.innerHTML = this.value.replace(/\s/g, "&nbsp;");
        this.style.width = span.offsetWidth + "px";
      });
    },
    onInputPeerFeedbackModel(event, index) {
      const el = document.getElementById(`input-peer-growup-${this.popover.langPeerFeedback.toLowerCase()}-${index}`);
      const span = document.getElementById(`span-peer-growup-${this.popover.langPeerFeedback.toLowerCase()}-${index}`);
      el.addEventListener("input", function (event) {
        span.innerHTML = this.value.replace(/\s/g, "&nbsp;");
        this.style.width = span.offsetWidth + "px";
      });
    },
    pendingAfterChange(min) {
      this.overdueMonths = _.filter([2, 3, 4, 5, 6], (value) => value > min);
      if (min < this.overdueMonths[0]) {
        this.settingData.performance_review.overdue = this.overdueMonths[0];
      }
    },




    createPreset(){
     // console.log('createPreset')
      this.selected_team=[]
      this.selected_user=[]
      this.status_edit_preset=false
      this.title_preset='Create Preset'
      this.status_show_preset_forms = false
      this.createPreset_status = true
      this.presetForm={
        preset_id:'',
        name: '',
        dayoff: [],
        company_holiday: true,
        users:[],
        teams:[],
      }
      this.presetForm_old={
        preset_id:'',
        name: '',
        dayoff: [],
        company_holiday: true,
        users:[],
        teams:[],
      }
      
    },
    closeModalHolidayPresets() {
      this.showModal_holiday_presets = false;
    },
    handleCheckedDayChange(value) {
      this.presetForm.dayoff=value
    },
    openAddMemberTeam(type){
      this.addMemberTeamForm.team=[]
      this.addMemberTeamForm.user=[]
      this.addMemberTeam = true
      if(type=='member'){
        this.addMemberTeamForm.type='member'
        this.addMemberTeamForm.title_left='members selected'
        this.addMemberTeamForm.title=`Add members to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.placeholder='Search member name'

        for(const key in this.member){

          const _user=_.find(this.selected_user,function(item){return item.email==key})
          if(_user){ 
            this.addMemberTeamForm.user.push({key:key,statusClick:true,...this.member[key]})
          }else{
            this.addMemberTeamForm.user.push({key:key,statusClick:false,...this.member[key]})
          }
          
        }
        //console.log('addMemberTeamForm',this.addMemberTeamForm)
       
      }else{
        // console.log('add team',this.memberInteamAll)
        this.addMemberTeamForm.type='team'
        this.addMemberTeamForm.title=`Add teams to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.title_left='teams selected'
        this.addMemberTeamForm.placeholder='Search team name'
        //console.log("key",this.selected_team)
        for(const key in this.memberInteam){
          
          const _team=_.find(this.selected_team,function(item){return item.id==key})
          if(_team){ 
            this.addMemberTeamForm.team.push({key:key,statusClick:true,...this.memberInteam[key]})
          }else{
            this.addMemberTeamForm.team.push({key:key,statusClick:false,...this.memberInteam[key]})
          }
          
        }
        

      }
      //console.log('addMemberTeamForm',this.addMemberTeamForm)
    },
    cancelselectedTeamandMember(){
      //console.log('cancelselectedTeamandMember',this.addMemberTeamForm.type)
      if(this.addMemberTeamForm.type=='team'){
        this.selected_team=this.presetForm&&this.presetForm.team?this.presetForm.team:[]
      }else{
        this.selected_user=this.presetForm&&this.presetForm.users?this.presetForm.users:[]
      }
     this.searchmemberandteamandMember=''
      this.addMemberTeam = false
   
    },
    submitselectedTeamandMember(){
      this.checkTeamAndMember()
      this.checkedChanges()
    },
    async deleteUser(email){
      this.presetForm.users= _.filter(this.presetForm.users,(obj)=>{return obj.email!==email})
      this.selected_user=_.filter(this.selected_user,(obj)=>{return obj.email!==email})
      for(const key in this.addMemberTeamForm.user){
        if(email==this.addMemberTeamForm.user[key].email){
          this.addMemberTeamForm.user[key].statusClick=false
        }
      }
      this.checkedChanges()
      this.$forceUpdate()
      
    },
    deleteTeam(team){
      //console.log('deleteTeam', team)
      this.presetForm.team= _.filter(this.presetForm.team,(obj)=>{return obj.id!==team})
      this.selected_team=_.filter(this.selected_team,(obj)=>{return obj.id!==team})
      
      for(const key in this.addMemberTeamForm.team){
        if(team==this.addMemberTeamForm.team[key].id){
          this.addMemberTeamForm.team[key].statusClick=false
        }
      }
      this.checkedChanges()
      this.$forceUpdate()
    },
    checkedChanges() {
      
      const check_preset=_.isEqual(this.presetForm,this.presetForm_old)
      if(!check_preset){
        if(this.createPreset_status){
          this.popup_preset={
          show:true,
          title:'Create new preset',
          content:'',
          status:'create',
          button_left:'Clear',
          button_right:'Save Preset',
          }

        }else {
          this.popup_preset={
          show:true,
          title:'Update your preset',
          content:'',
          status:'update',
          button_left:'Delete',
          button_right:'Save Changes',
          }

        }
        
      }else{
        if(this.status_edit_preset){
          this.popup_preset={
          show:true,
          title:'Update your preset',
          content:'',
          status:'update',
          button_left:'Delete',
          button_right:'',
          }
        }else{
          // console.log('no changes')
        this.popup_preset={
            show:false,
            title:'',
            content:'',
            button_left:'',
            button_right:'',
            }

        }
      
      }
    },
    selectedTeamAndMember(id,type){

      if(type=='team'){
      this.addMemberTeamForm.team[id].statusClick=!this.addMemberTeamForm.team[id].statusClick
      const _find_team=this.selected_team.filter((item)=>{return item.id===this.addMemberTeamForm.team[id].id})
      if(_find_team.length==0){
        this.selected_team.push({membersteams:this.addMemberTeamForm.team[id].users?this.addMemberTeamForm.team[id].users.length:0,name:this.addMemberTeamForm.team[id].name,id:this.addMemberTeamForm.team[id].id,newteam:true})
      }else{
        this.selected_team=this.selected_team.filter((item)=>{return item.id!==this.addMemberTeamForm.team[id].id})
      }
      // this.selected_team=this.addMemberTeamForm.team[id]
      }else{       

        this.addMemberTeamForm.user[id].statusClick=!this.addMemberTeamForm.user[id].statusClick
        const _find_user=this.selected_user.filter((item)=>{return item.email===this.addMemberTeamForm.user[id].email})
        if(_find_user.length==0){
          this.selected_user.push({email:this.addMemberTeamForm.user[id].email,firstname  :this.addMemberTeamForm.user[id].firstname,lastname:this.addMemberTeamForm.user[id].lastname,team_name:this.addMemberTeamForm.user[id].team_name,profilepic_crop:this.addMemberTeamForm.user[id]&&this.addMemberTeamForm.user[id].profilepic_crop?this.addMemberTeamForm.user[id].profilepic_crop:'',newuser:true})
        }else{
          this.selected_user=this.selected_user.filter((item)=>{return item.email!==this.addMemberTeamForm.user[id].email})
        }
      }


      this.$forceUpdate()
    },
    async savePreset(){
     // console.log('savePreset')
      //this.verifyPreset()
      // if(this.presetForm_verify.name==true||this.presetForm_verify.goals==true||this.presetForm_verify.culture==true||this.presetForm_verify.next_review==true){
      //   return
      // }else{
        this.$store.dispatch('settings/updateAndCreatePreset',{preset:this.presetForm,duplicate:this.duplicateTeamandMamger})
        this.status_duplicate=false
        this.clearData()

      //}
      
    },
    clearData(){
      this.createPreset_status = false
      this.presetForm={
        preset_id:'',
        name: '',
        dayoff: [],
        company_holiday: true,
        users:[],
        teams:[],
      }
      this.presetForm_old={
        preset_id:'',
        name: '',
        dayoff: [],
        company_holiday: true,
        users:[],
        teams:[],
      }
      this.index_focus=''
      this.status_edit_preset=false
      this.status_show_preset_forms=true
      this.status_edit_preset=false
    },
    async deletePreset(){
      //console.log('deletePreset')
      this.$store.dispatch('settings/deletePreset',{preset_id:this.presetForm.preset_id})
      this.clearData()
    },
    checkTeamAndMember(){
      this.text_confirm=[]

      //console.log('checkTeamAndMember',this.presetlistAll)
      const _presetlistAll=_.cloneDeep(this.presetlistAll)
      
      let _presetlistChange=_.cloneDeep(this.presetlistAll)
      if(this.status_duplicate==true){
        _presetlistChange=this.duplicateTeamandMamger
      }
      
      if(this.addMemberTeamForm.type=='team'){
        for(const key in _presetlistAll){
          //console.log('key',key)
          const teams=[]
          _presetlistChange[key].teams=[]
          if(_presetlistAll[key].teams){
              for(const team of _presetlistAll[key].teams){
              //console.log('team',team)
              const _find_team=this.selected_team.filter((item)=>{return item.id===team})
              if(_find_team.length>0){
                if(_find_team[0].newteam){
                  const text=`• Team "${_find_team[0].name}" is currently assigned to "${_presetlistAll[key].name}" preset`
                  this.text_confirm.push(text)
                  _presetlistChange[key].status_duplicate_team=true 
                  this.status_duplicate=true
                }
              }else{
                teams.push(team)
              }

            }
            if(teams.length>0){
              _presetlistChange[key].teams=teams
            }

          }
          
        }
      
        this.duplicateTeamandMamger=_presetlistChange
        this.confirm_add_dialog=true
      }else{
        for(const key in _presetlistAll){
          
          const users=[]
          _presetlistChange[key].users=[]
          if(_presetlistAll[key].users){
            for(const user of _presetlistAll[key].users){
            const _find_user=this.selected_user.filter((item)=>{return item.email===user})

            if(_find_user.length>0){
              if(_find_user[0].newuser){
                const text=`• Member "${_find_user[0].firstname} ${_find_user[0].lastname}" is currently assigned to "${_presetlistAll[key].name}" preset`
                this.text_confirm.push(text)
                _presetlistChange[key].status_duplicate_user=true
                this.status_duplicate=true
              }
            }else{
              _presetlistChange[key].users.push(user)

            }

            }
          }
        }
       
        this.duplicateTeamandMamger=_presetlistChange
        this.confirm_add_dialog=true
      }
      if(this.text_confirm==''){
        this.confirm_Add()
      }

    },
    handleClose(){
      this.confirm_add_dialog = false
    },
    confirm_Add(){

      if(this.addMemberTeamForm.type=='team'){
        this.presetForm.team=this.selected_team
      }else{
        this.presetForm.users=this.selected_user
      }
      this.addMemberTeam = false
      this.searchmemberandteamandMember=''
      this.confirm_add_dialog = false
      this.checkedChanges()
    },
    gettextAssigned(team,member){
      if(team>0&&member==0){
        if(team==1){return 'Assigned to 1 team'}
        return `Assigned to ${team} teams`
      }else if(team==0&&member>0){
        if(member==1){return 'Assigned to 1 member'}
        return `Assigned to ${member} members`
      }else{
        if(team==1&&member==1){return 'Assigned to 1 team and 1 member'}
        return `Assigned to ${team} teams and ${member} members`
      }
    },
    ClickEditPresets(item){
     // console.log('ClickEditPresets',this.presetlist[item])
      const _presetlist=_.cloneDeep(this.presetlist[item])
      this.title_preset='Edit Preset'
      if(this.index_focus!==''){
        this.presetlist[this.index_focus].focus_preset = false
      }
      const holiday_day=[]
      if(_presetlist.holiday_day){
        for(const key in _presetlist.holiday_day){
          if(_presetlist.holiday_day[key]){
            holiday_day.push(key)
          }
        }
      }
      this.status_edit_preset=true
      this.presetlist[item].focus_preset = true
      this.status_show_preset_forms = false
      this.presetForm.preset_id = _presetlist.id
      this.presetForm.name = _presetlist.name || ''
      this.presetForm.dayoff =holiday_day || []
      this.presetForm.company_holiday = _presetlist.company_holiday || false
      // this.presetForm.goals = _presetlist.goals || ''
      // this.presetForm.culture = _presetlist.culture || ''
      // this.presetForm.next_review =_presetlist.next_review || ''
      this.presetForm.team = _presetlist.team || []
      this.presetForm.users =_presetlist.data_users || []
      this.presetForm.team =_presetlist.data_team || []
      this.selected_team=_.cloneDeep(this.presetForm.team)
      this.selected_user=_.cloneDeep(this.presetForm.users)
      this.presetForm_old = _.cloneDeep(this.presetForm)
      this.index_focus=item
  
    },
  }
}
</script>
<style scoped>
.btnAddSettings {
  width: 172px;
  height: 52px;
  font-size: 18px;
  font-weight: 700;
}

.div-page-content {
  flex: 1;
}

.inputLabelStyle {
  width: 138px;
  padding-top: 6px;
  color: #4a4a4a;
  font-size: 16px;
  font-weight: 500;
  display: inline-block;
  text-align: right;
}

.inputReportStyle {
  font-size: 18px;
  width: 250px !important;
  margin-left: 12px;
}

.inputReportStyle.red>>>input.el-input__inner {
  border-color: #f44336;
}

.inputMedalStyle {
  font-size: 12px;
  width: 90px;
}

.popup {
  display: none;
  position: absolute;
  min-width: 120px;
  border-radius: 4px;
  padding: 10px 12px;
  background: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  transition: 0.2s;
}

.input-medal {
  font-size: 12px;
  font-weight: 700;
  color: #454545;
  width: 68px;
  height: 30px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #c7c7c7;
  transition: 0.2s;
}

.input-medal:focus-visible,
.input-medal:focus {
  outline: 0;
  border: 1px solid #6c30cc;
}

.input-medal:hover~.popup,
.input-medal:focus~.popup {
  display: block;
}

.recognition-tags:hover~.popup,
.recognition-tags:focus~.popup {
  display: block;
  color: #000;
  background: #fff;
  z-index: 999;
}

.peer-feedback-tags:hover~.popup,
.peer-feedback-tags:focus~.popup {
  display: block;
  color: #000;
  background: #fff;
  z-index: 999;
}

.imgMedal {
  display: block;
  margin: auto;
  width: 72px;
  height: 101.89px;
}

.HolidayTagStyle {
  color: #484848;
  border-width: 1px;
  border-color: #747474;
  background-color: #f7f7f7;
  margin-right: 8px;
  margin-bottom: 8px;
  font-weight: 700;
  font-size: 12px;
  color: #747474;
}

.HolidayTagStyle.el-tag {
  padding: 0px 12px;
}

.el-tag .el-icon-close,
.el-tag .el-icon-close:hover {
  color: #747474;
  background: transparent;
}

.el-input.is-disabled>>>.el-input__inner {
  background-color: #f2f2f2;
  border-color: #c7c7c7;
  color: #747474 !important;
}

#formReport .el-input>>>.el-input__inner {
  color: #3b3b3b;
  font-weight: 400;
  height: 52px;
}

#formReport .el-input--prefix>>>.el-input__icon {
  padding-left: 6px;
}

#formReport .el-input--prefix>>>.el-input__inner {
  padding-left: 140px;
}

#formMedal .el-input>>>.el-input__inner {
  text-align: center;
  color: #454545;
  border-color: #c7c7c7;
  font-weight: 700;
  height: 32px;
  text-overflow: ellipsis;
}

#formMedal .el-input>>>.el-input__inner:focus {
  outline: none;
  border-color: #797979;
}

.el-button--primary {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
}

.el-button--primary:hover,
.el-button--primary:focus {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 0.7;
}

.el-button--primary:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}

.dialogInputDatepicker>>>input.el-input__inner {
  opacity: 0;
  cursor: default;
  padding: 0px;
  height: 33px;
  width: 159px;
}

.dialogInputDatepicker>>>span.el-input__prefix {
  display: none;
}

.btn_AddHolidayStyle {
  position: absolute;
  cursor: pointer;
  width: 159px;
  height: 33px;
}

.txt-header {
  width: 170px;
  color: #3b3b3b;
  font-size: 18px;
  font-weight: 700;
  display: inline-block;
  text-align: left;
}

.txt-description {
  color: #4a4a4a;
  font-size: 14px;
}

.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  background: #00acc1;
  border: none;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  margin-top: 10px;
}

.button-new-tag:hover {
  background: #00acc1;
  color: #ffffff;
}

.input-new-tag {
  width: 98px;
  vertical-align: bottom;
  margin-top: 10px;
}

.el-tag-peer-feedback {
  background: #00acc1;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  margin-right: 10px;
  margin-top: 10px;
}

.header-text {
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 6px;
}

.description-text {
  font-size: 14px;
  color: #4a4a4a;
  width: 740px;
  margin-right: auto;
}
.modal-1{
    overflow-y: scroll;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 0px 40px 40px 0px;
    opacity: 1;
    height: 84vh;
    min-height: 847px;
    padding-left: 40px;

    max-height: 1200px;

}
.modal-2{
  overflow-y: scroll;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 84vh;
  padding-left: 42px;
  padding-right: 42px;
  min-height: 847px;
  max-height: 1200px;
  position: relative;
}
.btn-preset{
  width: 200px;
  height: 33px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  span span{
    padding: 0px;
  }
}
</style>
<style lang="scss" scoped>
input {
  outline: 0;
}

.input-growup {
  width: 100px;
  outline: 0;
  padding: 4px 28px 4px 12px !important;
  min-height: 19px;

  &:focus {
    border-color: #6c30cc;
  }
}

.span-growup {
  position: absolute;
  left: -9999px;
  display: inline-block;
  min-width: 6em;
}

.setting-row {
  transition: 0.2s;
}

.expand-setting {
  height: 0px;
  overflow: hidden;
}

.recognition-tags {
  font-size: 13px;
  font-weight: 700;
  border: 2px solid #00acc1;
  color: #00acc1;
  border-radius: 30px;
  padding: 5px 12px 3px;
  margin-right: 6px;
  transition: 0.2s;

  &:hover {
    background-color: #00abc118;
  }
}

.recognition-tags~.icon-close {
  right: 18px;
  top: 7px;
  position: absolute;
  color: #00acc1;
}

.recognition-tags.disable {
  opacity: 0.2;
  border: 2px solid #000;
  color: #000;

  &:hover {
    background-color: #fff;
  }
}

.peer-feedback-tags {
  font-size: 13px;
  font-weight: 700;
  border: 2px solid #00acc1;
  background-color: #00acc1;
  color: #fff;
  border-radius: 4px;
  margin-right: 6px;
  padding: 5px 12px 3px 12px;
  transition: 0.2s;

  &:hover {
    background-color: #02a2b8;
  }
}

.peer-feedback-tags~.icon-close {
  right: 18px;
  top: 7px;
  position: absolute;
  color: #fff;
}

.peer-feedback-tags.disable {
  opacity: 0.2;
  border: 2px solid #000;
  background-color: #000;
  color: #fff;

  &:hover {
    background-color: #000;
  }
}

.lang-button {
  height: 32px;
  width: 64px;
  border-radius: 4px;
  padding: 0px;
  border: 1px solid #c7c7c7;
  margin-top: auto;
  color: #000;
  font-size: 13px;
  font-weight: 400;
}
</style>
<style lang="scss">
#divMedal span.el-switch__core {
  height: 14px;
  width: 27px !important;
  border: none;
}

#divMedal span.el-switch__core::after {
  background: #ffffff;
  width: 10px;
  height: 10px;
  position: absolute;
  margin-top: 1px;
  margin-left: 1px;
}

#divMedal .el-switch.is-checked .el-switch__core::after {
  margin-left: -12px;
  margin-top: 1px;
}

#tagPeer i.el-tag__close.el-icon-close {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}

#tagPeer i.el-tag__close.el-icon-close:hover {
  font-size: 16px;
  color: #ffffff;
  background: transparent;
}

.select-lang.in-popover {
  height: 28px;
  width: calc(100% - 12px);
  font-size: 13px;
  color: #000;
  transition: 0.2s;
  border-radius: 4px;
  cursor: pointer;
  padding-left: 12px;
}

.select-lang.in-popover:hover {
  color: #6c30cc;
  background: rgba(#6c30cc, 0.2);
}

.el-slider__button {
  width: 32px;
  height: 32px;
  border: solid 3px #32C2D5;
  box-shadow: 0 0 6px rgba(0,0,0,0.16);
}
.el-slider__bar {
  background-color: #32C2D5;
}
.el-slider__marks-text {
    font-size: 14px;
    color: #000000;
    margin-top: 32px;
    font-weight: 700;
}
#settingContainer .el-dialog > .el-dialog__header {
  padding: 0px;
}
#settingContainer .el-dialog>.el-dialog__body {
  padding: 0px;
  height: 84vh;
  min-height: 847px;
  max-height: 1200px;
}
.key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px 5px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.9), rgba(240, 240, 240, 0.7));
  border-radius: 3px;
  border: 1px solid rgba(180, 180, 180, 0.5);
  border-bottom: 1px solid rgba(150, 150, 150, 0.6);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.7);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);
  margin: 0 2px;
  font-weight: 500;
  font-size: 9px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  min-width: 16px;
  height: 20px;
  color: rgba(0, 0, 0, 0.8);
}
</style>